export default "/assets/images/overreactor-crop.2c8cacc6c23583fc.png";